module.exports = __webpack_public_path__ + "static/media/41-4.8321d4b4.mp3";